import {lazy} from "../../lib/lazy.js";
export const warehouseStockDetailsRoutes = [
  {
    path: "/warehouse-stock-details",
    component: lazy(() => import(/* webpackChunkName: "warehouseStockDetailsRoutes" */ "../../views/warehouse-stock-details/index.js"))
  }
];
